import {defaultErrorMessage} from '@cohort/shared/models';
import {CohortError} from '@cohort/shared-frontend/common/errors';
import useNotify from '@cohort/wallet/hooks/notify';
import {t} from 'i18next';
import {useCallback} from 'react';

export default function useOrderSessionErrors(): (err: unknown) => void {
  const notify = useNotify();

  return useCallback(
    (err: unknown) => {
      if (err instanceof CohortError) {
        switch (err.code) {
          case 'campaign.ended':
            notify('error', t('orderSession.campaignEnded', {ns: 'lib'}), {autoClose: false});
            break;
          case 'campaign.not-enough-tokens':
          case 'campaign.tokens-not-available':
            notify('error', t('orderSession.tokenNotAvailable', {ns: 'lib'}), {autoClose: false});
            break;
          case 'digital-asset-collection.max-ownerships-reached':
            notify('error', t('orderSession.campaignAlreadyOrderedByOwner', {ns: 'lib'}), {
              autoClose: false,
            });
            break;
          case 'campaign.user-not-in-cohort':
            notify('error', t('orderSession.userNotInCohort', {ns: 'lib'}), {
              autoClose: false,
            });
            break;
          case 'campaign.redeem-code-missing':
          case 'redeem-code.code-invalid':
          case 'redeem-code.not-found':
            notify('error', t('orderSession.invalidRedeemCode', {ns: 'lib'}), {
              autoClose: false,
            });
            break;
          default:
            break;
        }
        notify('error', defaultErrorMessage, {autoClose: false});
      }
    },
    [notify]
  );
}
